import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { styled } from '@mui/material/styles';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const Root = styled('div')({
  width: sidebarConfig.drawerWidthClosed,
  height: 3 * sidebarConfig.logoHeight,
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  marginBottom: -14,
});

const StyledLink = styled(Link)({
  width: sidebarConfig.drawerWidthClosed,
  marginLeft: 24,
});

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <Root>
      <StyledLink to="/" underline="none" aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </StyledLink>
    </Root>
  );
};
